class LaunchAppUI {
    constructor() {
        // 单位转换->vw
        this.toVw = (styleValue) => {
            const str = String(styleValue);
            if (str.match(/(\d*\.?\d+)rpx([\s;,)}]|$)/g)) {
                const ratio = `${100 / 750}`;
                return str.replace(/(\d*\.?\d+)rpx([\s;,)}]|$)/g, (...arg) => `${arg[1] * ratio}vw${arg[2]}`);
            }
            else {
                return str;
            }
        };
    }
    // 创建dom
    createUI(vDom, container = document.body) {
        if (Object.prototype.toString.call(vDom) !== '[object Object]')
            return;
        // 解构赋值
        const { domKey, tag, props, style, events, text, children = [] } = vDom;
        // 创建dom元素
        const el = document.createElement(tag);
        this[domKey] = el;
        this.dealNode(domKey, { props, style, events, text });
        // 递归创建子元素
        children.forEach(item => {
            this.createUI(item, el);
        });
        // 在容器内添加元素
        container.appendChild(el);
    }
    // 创建dom
    removeUI(targetDom) {
        this[targetDom] && this[targetDom].remove();
        this[targetDom] = undefined;
    }
    // 更新dom节点
    updateNode(targetDom, params) {
        this.dealNode(targetDom, params);
    }
    // dom节点赋值
    dealNode(targetDom, params) {
        const { props = {}, style = {}, events = {}, text = '' } = params;
        if (text)
            this[targetDom].innerText = text;
        // 设置样式
        for (const key in style) {
            this[targetDom].style[key] = this.toVw(style[key]);
        }
        // 设置dom属性
        for (let key in props) {
            this[targetDom].setAttribute(key, props[key]);
        }
        // 绑定事件
        for (let key in events) {
            this[targetDom].addEventListener(key, events[key]);
        }
    }
}
export default LaunchAppUI;
